export const AUTHENTICATE = 'AUTHENTICATE';
export const AUTHENTICATE_ERROR_AUTH = 'AUTHENTICATE_ERROR_AUTH';
export const CLEAR_ALL = 'CLEARSTORE';

export function auth({ name, avatar,bearerToken,instId,role,roleId }) {
  return {
    type: AUTHENTICATE,
    user: { name, avatar,bearerToken,instId,role,roleId },
  };
}

export function authError(error) {
  return {
    type: AUTHENTICATE_ERROR_AUTH,
    error,
  };
}

export function clearAll(error) {
  return {
    type: CLEAR_ALL,
    error,
  };
}
